import { getJson } from "./networkService";
import { put } from "./networkService";

export async function getClientDetails(accountNumber) {
  return getJson(`/clients/${accountNumber}/details`);
}

export async function updateClientDetails(clientDetails) {
  return put(`/clients`,  clientDetails );
}